import { render, staticRenderFns } from "./ecommerce.vue?vue&type=template&id=706f64f2&"
import script from "./ecommerce.vue?vue&type=script&lang=js&"
export * from "./ecommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports